import React from "react";
import { Features } from "../components";

export function FeaturesContainer({ children }) {
  return (
    <Features>
      <Features.TextHeading>Features</Features.TextHeading>
      <Features.Line />
      <Features.Frame>
        <Features.Pane>
          <Features.Logo src="/images/icons/surface1.png" />
          <Features.Content>
            <Features.Heading>Check-in via iPad </Features.Heading>
            <Features.Text>
              {" "}
              Our highly skilled team members, design and develop the Smart Apps
              using industry's latest, reliable, secure and scalable platforms.
              We belive in ajile methodology.
            </Features.Text>
          </Features.Content>
        </Features.Pane>
        <Features.Pane>
          <Features.Logo src="/images/icons/Vector (1).png" />
          <Features.Content>
            <Features.Heading>Data is always Safe </Features.Heading>
            <Features.Text>
              {" "}
              We believe in supporting local businesses to develop a cohesive
              eco-system. Our application Data is stored locally. Our services
              are hosted at OOREDOO DC.
            </Features.Text>
          </Features.Content>
        </Features.Pane>
        <Features.Pane>
          <Features.Logo src="/images/icons/list 4 (1).png" />
          <Features.Content>
            <Features.Heading>High-End Anaylizing </Features.Heading>
            <Features.Text>
              {" "}
              We provide a “data-driven” approach, it means you can make
              strategic decisions based on data analysis and interpretations.
              VMS Data analytics dashboard is very intuitive.
            </Features.Text>
          </Features.Content>
        </Features.Pane>
        <Features.Pane>
          <Features.Logo src="/images/icons/shuttle 1.png" />
          <Features.Content>
            <Features.Heading>Our Dedicated Support </Features.Heading>
            <Features.Text>
              {" "}
              We provide 24x7 on-call support to our customers and on top of
              those services, we provide regular training to FM Managers,
              on-site staff like Concierge Admins, Security Guards and other
              attending staff members.
            </Features.Text>
          </Features.Content>
        </Features.Pane>
      </Features.Frame>
    </Features>
  );
}
